<template>
    <h2 class="heading">{{ expense.id == null ? 'Add New' : 'Edit' }} Expense Request</h2>
    <div class="form">
        <el-form :model="expense" label-width="130px" style="width:100%;" >
            <el-form-item label="Title" required>
                <el-input v-model="expense.title" minlength="2" maxlength="200" show-word-limit="true"/>
            </el-form-item>

            <el-form-item label="Type" required>
                <el-select v-model="expense.type" placeholder="Expense type" style="width:300px" >
                    <el-option v-for="type in types" :key="type" :label="type" :value="type"/>
                </el-select>

                <span class="required" style="margin-left:50px; margin-right:5px;">*</span>
                <span style="margin-right:8px;">Category</span>
                <el-select v-model="expense.category" placeholder="Category" style="width:300px;" >
                    <el-option v-for="cat in categories" :key="cat" :label="cat" :value="cat"/>
                </el-select>
            </el-form-item>

            <el-form-item label="Requester" required>
                <el-input v-model="expense.requester" minlength="2" style="width:300px;" maxlength="200" show-word-limit="true"/>

                <span class="required" style="margin-left:50px; margin-right:5px;">*</span>
                <span style="margin-right:8px;">Approver</span>
                <el-select v-model="expense.approver" placeholder="Approver" style="width:300px">
                    <el-option v-for="approver in approvers" :key="approver" :label="approver" :value="approver" />
                </el-select>
            </el-form-item>

            <el-form-item label="Request date" required>
                <el-date-picker v-model="expense.requestDate" type="date"  
                    placeholder="Request Date" value-format="YYYY-MM-DD"></el-date-picker>

                <span class="required" style="margin-left:130px; margin-right:5px;">*</span>
                <span style="margin-right:8px;">Total Amount:</span>
                <span class="amount" style="font-size:1.1em;">{{totalAmount}}</span> 
                <span class="unit" style="margin-left:8px;">HKD</span>
            </el-form-item>

            <el-form-item label="Attachment">
                <el-tag v-for="(item, index) in attachments" :key="index" size="large" closable @close="removeFile(item)">
                    <a href="" @click.prevent="global.down(item.link, item.name)">{{item.name}}</a></el-tag>
                <el-upload multiple :action="global.upload_path"
                    :on-success="uploaded"
                    :data="{'type':'expense'}"
                    :show-file-list="false">
                    <el-button type="primary">Click to upload</el-button>
                </el-upload>
            </el-form-item>

            <el-form-item label="Status" v-if="expense.status == 'Rejected'">
                <span :class="expense.status"><b>{{ expense.status }}</b></span>

                <span style="margin-right:8px;margin-left:130px;">Approver's comments:</span>
                <span :class="expense.status">{{ expense.rejectReason}}</span>
            </el-form-item>

            <el-form-item>
                <template #label>
                    <div>
                        Detail Items
                        <div><el-button @click="addNewItem" style="margin-top:20px">+ Add Item</el-button></div>
                        <div style="margin-top:20px;">
                            <el-upload :action="global.upload_domain + '/user-api/uploadExpenseDetails'"
                                :on-success="uploadExpenseItems"
                                :data="{'type':'expenseDetail'}"
                                :show-file-list="false">
                                <el-button type="warning">Batch Upload Items</el-button>
                            </el-upload>
                        </div>

                        <div style="margin-top:10px; text-align:center;">
                            <a href="" @click.prevent="global.down('/upload/expense_items_upload_template.xlsx', 'expense_items_upload_template.xlsx')" 
                            style="font-size:13px; color:#26B;">Upload Template</a>
                        </div>
                    </div>
                </template>
                <el-table :data="expenseDetails" id="itemList" :style="expenseDetails.length>8?'height:500px;':'max-height:500px;'" :row-class-name="tableRowClassName">
                    <el-table-column type="index" label="No" align="center" />
                    <el-table-column prop="date" label="Date" width="100" align="center" />
                    <el-table-column prop="category" label="Category" width="200"/>
                    <el-table-column prop="description" label="Description" width="220"/>
                    <el-table-column prop="paidTo" label="Paid to" width="180"/>
                    <el-table-column prop="amount" align="right" label="Amount">
                        <template #default="scope">{{global.number_format(scope.row.amount, 2)}}</template>
                    </el-table-column>
                    <el-table-column prop="ccy" label="CCY"/>
                    <el-table-column prop="fxRate" label="FX rate" align="right" width="60">
                        <template #default="scope">{{global.number_format(scope.row.fxRate, 2)}}</template>
                    </el-table-column>
                    <el-table-column prop="amountHKD" label="Amt(HKD)" align="right">
                        <template #default="scope">{{global.number_format(scope.row.amountHKD, 2)}}</template>
                    </el-table-column>
                    <el-table-column prop="capIfApplicable" label="Cap" align="right"/>
                    <el-table-column prop="reimbursableAmtHKD" label="Reimbuse Amt(HKD)" align="right">
                        <template #default="scope"><span class="amount">{{global.number_format(scope.row.reimbursableAmtHKD, 2)}}</span></template>
                    </el-table-column>
                    <el-table-column type="index" label="Action" align="right" width="100">
                        <template #default="{ $index }">
                            <el-icon :size="16" @click="editItem($index)" style="cursor:pointer; margin-right:5px" title="Edit"><Edit /></el-icon>
                            <el-icon :size="16" @click="deleteItem($index)" style="cursor:pointer" title="Delete"><Delete /></el-icon>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
           
            <el-form-item label="">
                <el-button type="success" v-if="expense.id == null || expense.status == 'Draft'" @click="submitExpense('Draft')">Save as draft</el-button>
                <el-button type="primary" @click="submitExpense">Submit the request</el-button> 
                <el-button type="default" onclick="history.back()" >Cancel</el-button>
                <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
                <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                    <img src="@/assets/loading.gif" style="height:24px;"/>
                </span>
            </el-form-item>
        </el-form>
    </div>

    <el-dialog v-model="dialogFormVisible" title="Add / Edit Expense Item" width="1100px" center>
        <el-form :model="item" label-width="160px" style="width:100%" >
            <el-form-item label="Date" required>
                <el-date-picker v-model="item.date" type="date" placeholder="Expense Date" value-format="YYYY-MM-DD" style="width:300px;"/>
            </el-form-item>

            <el-form-item label="Category" required>
                <el-select v-model="item.category" placeholder="Category" style="width:300px;">
                    <el-option v-for="cat in expenseCategories" :key="cat" :label="cat" :value="cat" />
                    <el-option label="Others" value="Others" />
                </el-select>
                <el-input v-model="item.category2" v-if="item.category=='Others'" placeholder="Others please specify"
                    style="width:350px; margin-left:10px;" maxlength="100" show-word-limit="true"/>
            </el-form-item>

            <el-form-item label="Description" >
                <el-input type="text" v-model="item.description" placeholder="Decription"/>
            </el-form-item>

            <el-form-item label="Invoice">
                <el-input type="text" v-model="item.invoice" placeholder="Invoice"/>
            </el-form-item>

            <el-form-item label="Paid to" required>
                <el-input type="text" v-model="item.paidTo" placeholder="Paid to"/>
            </el-form-item>

            <el-form-item label="Amount" required>
                <el-input-number v-model="item.amount" :min="0" :max="100000000" precision="0" style="width:200px;"/>
                <el-select v-model="item.ccy" placeholder="Currency" style="margin-left:10px; width:100px;">
                    <el-option v-for="ccy in currencies" :key="ccy" :label="ccy" :value="ccy" />
                </el-select>
            </el-form-item>

            <el-form-item label="FX rate" required>
                <el-input-number v-model="item.fxRate" :min="0" :max="1000000" precision="4" style="width:200px;"/>
            </el-form-item>

            <el-form-item label="Amount in HKD" required>
                <span class="amount">{{global.number_format(item.fxRate * item.amount, 2)}}</span>
                <span class="unit">HKD</span>
            </el-form-item>

            <el-form-item label="Cap (if applicable)">
                 <el-input-number v-model="item.cap" :min="0" :max="100000000" precision="2" style="width:200px;"/>
                 <span class="unit">HKD</span> 
            </el-form-item>

            <el-form-item label="Reimbursable Amt" required>
                 <el-input-number v-model="item.reimbursableAmtHKD" :min="0" :max="100000000" precision="2" style="width:200px;"/>
                 <span class="unit">HKD</span>
            </el-form-item>

            <el-form-item label="" v-if="errMsg != ''">
                <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="addItem"> OK </el-button>
            </span>
        </template>
    </el-dialog>

</template>



<script>

const types = ['Business Expense Reimbursement', 'Mileage Reimbursement', 'Printing & Procurement'];
const categories = ['Premia Parnters', 'General'];
const approvers =['Rebecca Chua']
const currencies = ['HKD', 'KRW', 'SGD', 'TWD', 'USD', 'CNY', 'NZD', 'THB', 'JPY', 'CHF', 'EUR', 'MYR', 'SAR', 
                    'GBP', 'AUD', 'BND', 'AED', 'RMB', 'ILS', 'KWD', 'CAD', 'NTD', 'MOP', 'QAR', 'SEK', 'IDR', 
                    'BHD', 'DKK', 'MXN', 'PHP', 'DHS'];

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { Edit, Delete } from '@element-plus/icons-vue'

export default {
    components: {
        Edit, Delete
    },
    data() {
        return {
            categories, types, approvers, currencies,
            expense: {
                id: null, 
                title: null,
                requester: null,
                requestDate: null,
                category: null,
                approver: null,
                totalAmount: 0.0,
                currency: null,
                attachments: "",
            },
            dialogFormVisible: false,
            expenseCategories: [],
            item: this.getItem(),
            index: -1,
            expenseDetails: [],
            currentUser: null,
            errMsg: '',
            global,
            loading: false,
        }
    },
    async created() {
        console.log("created...");
        this.global.index = "expense";
        this.currentUser = this.global.currentUser;
        this.expense.requester = this.currentUser.fullname;
        //if (this.global.hasRight('expense', 'statistician')) {
        //    this.allUsers = await this.global.getAllUsers();
        //}
    },
    computed: {
        attachments() {
            let files = new Array();
            if (this.expense.attachments && this.expense.attachments.length) {
                let filesArr = this.expense.attachments.split(";")
                for (var i = 0; i < filesArr.length; i++) {
                    files.push({
                        name: filesArr[i].split(":")[0], 
                        link: filesArr[i].split(":")[1]
                    });
                }
            }
            return files;
        },
        totalAmount() {
            let totalAmount = 0.0;
            for (let i = 0; i < this.expenseDetails.length; i++) {
                totalAmount += this.expenseDetails[i].reimbursableAmtHKD;
            }
            return Math.round(totalAmount * 100) / 100.0;
        },
    },
    async mounted() {
        console.log("mounted...");
        let code = this.$route.query ? this.$route.query.code : null;
        let action = this.$route.query && this.$route.query.action ?  this.$route.query.action : null;
        if (code) {
            let result = await AXIOS("/expense/getExpense", {code: code});
            if (result.success) {
                this.expense = result.data.expense;
                this.expenseDetails = result.data.expenseDetails;
                this.expense.expenseJSON = null;
                this.expense.schemaInstance = null;
                this.expense.sheetSchemaInstance = null;
                if (action == 'copy') {
                    this.expense.id = null;
                }
            } else {
                this.errMsg = result.errMsg;
            }
        }
        let result = await AXIOS("/expense/getExpenseDetailCategories");
        if (result.success) {
            this.expenseCategories = result.data;
        }
    },
    methods: {
        removeFile(item) {
            let attachments = (this.expense.attachments + ";").replace(item.name+":"+item.link+";", "")
            this.expense.attachments = (attachments.length == 0) ? "" : attachments.substring(0, attachments.length-1);
        },
        uploaded(response) {
            let files = response.length ? response[0].name + ":" + response[0].url : '';
            if (files != '' && this.expense.attachments.indexOf(files) == -1) {
                this.expense.attachments = (this.expense.attachments == '') ? 
                    files : this.expense.attachments + ";" + files;
            }
        },
        uploadExpenseItems(response) {
            this.expenseDetails = response.length ? response : [];
        },
        editItem(index) {
            this.item = this.expenseDetails[index];
            this.index = index;
            this.dialogFormVisible = true;
        },
        deleteItem(index) {
            this.expenseDetails.splice(index, 1);
            this.index = -1;
        },
        addNewItem() {
            this.dialogFormVisible = true;
            this.errMsg = "";
            this.index = -1;
            this.item = this.getItem();
        },
        addItem() {
            this.errMsg = "";
            if (this.item.date == null) {
                this.errMsg = "Please select 'Date'"; return;
            }
            if (this.item.category == null || this.item.category == '') {
                this.errMsg = "Please select 'Category'"; return;
            } else if (this.item.category == "Others") {
                if (this.item.category2 == null || this.item.category2 == '') {
                    this.errMsg = "Please specify 'Other category'"; return;
                } else {
                    this.item.category = this.item.category2;
                }
            }
            if (this.item.description == null || this.item.description == '') {
                this.errMsg = "Please input 'Description'"; return;
            }
            if (this.item.paidTo == null || this.item.paidTo == '') {
                this.errMsg = "Please input 'Paid to'"; return;
            }
            if (this.item.amount == null || this.item.amount == 0) {
                this.errMsg = "Please input 'Amount'"; return;
            }
            if (this.item.ccy ==  null || this.item.ccy == '') {
                this.errMsg = "Please select 'Currency'"; return;
            }
            if (this.item.fxRate == null || this.item.fxRate == 0) {
                this.errMsg = "Please input 'FX rate'"; return;
            }
            if (this.item.reimbursableAmtHKD == null || this.item.reimbursableAmtHKD == 0) {
                this.errMsg = "Please input 'Reimbursable Amt HKD'"; return;
            }
            this.item.amountHKD = Math.round(this.item.fxRate * this.item.amount * 100) / 100.0;

            if (this.index == -1) {
                this.expenseDetails.push(this.item);
            } else {
                this.expenseDetails[this.index] = this.item;
                this.index = -1;
            }
            this.item = this.getItem();
            this.dialogFormVisible = false;
        },
        getItem() {
            return {
                date: null,
                category: null,
                category2: null,
                description: null,
                paidTo: null,
                invoice: null,
                amount: null,
                ccy: "HKD",
                fxRate: 1.0,
                cap: null,
                amountHKD: null,
                reimbursableAmtHKD: null,
            }
        },
        async submitExpense(status) {
            this.errMsg = "";
            if (this.expense.title == "") {
                this.errMsg = "[Title] is required";
                return;
            }
            if (this.expense.type == "") {
                this.errMsg = "Please choose [type]";
                return;
            }
            if (this.expense.category == "") {
                this.errMsg = "Please choose [Category]";
                return;
            }
            if (this.expense.requester == "") {
                this.errMsg = "[Requester] is required";
                return;
            }
            if (this.expense.approver == '') {
                this.errMsg = "[Approver] is required";
                return;
            }
            if (this.expense.requestDate == "") {
                this.errMsg = "[Request date] is required";
                return;
            }
            this.expense.totalAmount = this.totalAmount;
            this.expense.status = (status == 'Draft') ? 'Draft' : 'Pending Approval';

            if (this.loading) return;
            this.loading = true;
            let param = {expense: JSON.stringify(this.expense), expenseDetails: JSON.stringify(this.expenseDetails)};
            let result = await AXIOS("/expense/saveExpense", param);
            if (result.success) {
                this.$router.push("/expense/myExpenseList");
                console.log("Saved successfully!");
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .heading { width:900px; }
    .unit {margin-left:5px;}
    .amount {color:#26B; font-weight: bold;}
    .el-select {max-width:300px;}
    .link {color: #369;}
    .contractDetails { color:#999; font-size:13px; }
    .contractDetails span {color:#333; text-decoration: underline;}
    .required {color:#D00;}
    #itemList {width:99%; margin:0px auto 0px 0px;}
    .Rejected { color:#E20 !important; }
    .Approved { color:#0A2; }
</style>